import { createContextualCan } from '@casl/react'

import type { AppAbility } from './ability'
import { AbilityContext } from './AbilityContext'

export const Can = createContextualCan<AppAbility>(AbilityContext.Consumer)
